import { EmailEntryType } from '@maximizer/outlook/shared/domain';

export function extractMaximizerDomain(website: string): string {
  const urlSegments = website.split('/');
  const domainIndex = urlSegments.findIndex((segment) =>
    segment.toLowerCase().includes('maximizer'),
  );

  if (domainIndex === -1) {
    return '';
  }

  let domain = '';
  for (let i = 0; i <= domainIndex; i++) {
    domain += urlSegments[i] + '/';
  }
  return domain;
}

export function buildAccountLink(
  website: string,
  alias: string,
  isCloud: boolean,
): string {
  if (!isCloud) {
    return website;
  }

  // Cloud deep links target the web host (e.g. staging1 -> stagingw) plus the account alias.
  return extractMaximizerDomain(website).replace('1', 'w') + alias;
}

export type EntryLinkType = EmailEntryType | 'case' | 'opportunity';

const SEARCH_PARAMETER_BY_TYPE: Record<EntryLinkType, string> = {
  abentry: 'ss',
  lead: 'sslead',
  case: 'sscscase',
  opportunity: 'ssopp',
};

export function buildEntryDeepLink(
  accountLink: string,
  id: string,
  type: EntryLinkType,
): string {
  return `${accountLink}?${SEARCH_PARAMETER_BY_TYPE[type]}=KEY(${id})`;
}
